import React, { Component } from 'react';
import { Button } from '@material-ui/core';

class LogoutComponent extends Component {

  render() {
    return (
      <div style={{height: '100vh', display: 'flex', flexDirection:'column', justifyContent: 'center'}}>
        <h1 style={{textAlign:'center'}}>Se cerró la sesión</h1>
        <div  style={{display: 'flex', justifyContent: 'center'}}>
          <Button color="primary" variant="contained" onClick={() => { this.props.history.push('/#/search') }}>
              Volver a ingresar
          </Button>
        </div>
      </div>
    );
  }
}

export default LogoutComponent;
